import React from 'react';
import { Loader } from '@fourthwall/components';
import * as S from './EditorPanelLoader.styled';
export const EditorPanelLoader = () => (React.createElement(S.Container, null,
    React.createElement(Loader, { size: "large" })));
